import { Pagination } from '@mui/material';
import React from 'react';
import PaginationItem from '@mui/material/PaginationItem';
import { ReactComponent as Back } from '../svg/back.svg';
import { ReactComponent as Next } from '../svg/next.svg';
const Paging = ({ ...props }) => {
  return (
    <Pagination
      sx={{
        mt: 1
      }}
      {...props}
      renderItem={item => (
        <PaginationItem
          slots={{
            previous: Back,
            next: Next
          }}
          {...item}
        />
      )}
    />
  );
};

export default Paging;
